import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Legal() {
  return (
    <div className="App">
      <Header />
      <main className="xs-page" data-testid="legal-page">
        <div className="xs-container" style={{ maxWidth: 760 }}>
          <h1 style={{ color: "#ffde16", margin: "10px 0 4px" }}>legal</h1>
          <p style={{ opacity: 0.85, fontSize: "0.9em" }}>
            copyright, authorship, and blockchain proof-of-existence for content published on xaelserpent.com.
          </p>

          <article className="xs-article" style={{ padding: 0, marginTop: 14 }}>
            <h2>copyright ownership</h2>
            <p>
              copyright in a written or media work arises automatically, by operation of law, the moment
              the work is fixed in a tangible or digital form — no registration, notice, or filing is
              required to create it. every post, image, and media file published on this site is an
              original work of its author and is protected by copyright from the moment it is saved,
              independent of any technology described below.
            </p>

            <h2>how this site adds proof of existence</h2>
            <p>
              in addition to the copyright that already exists at the moment of authorship, this site
              is built to independently timestamp that moment using a public, third-party
              blockchain-anchoring service (OpenTimestamps):
            </p>
            <ol>
              <li>when a post is published, the server computes a one-way SHA-256 cryptographic hash of the canonical post content.</li>
              <li>that hash — not the content itself — is submitted to public OpenTimestamps calendar servers for anchoring.</li>
              <li>the calendar servers periodically aggregate submitted hashes into a Bitcoin blockchain transaction, producing a proof that a given hash existed at or before a specific block time.</li>
              <li>the resulting proof is stored by this site and shown on the published article and its blockchain badge, with a status of <em>submitted</em> (anchored) or <em>pending</em> (not yet confirmed) — publication is never blocked on this step.</li>
            </ol>
            <p>
              because SHA-256 is a one-way, collision-resistant hash function, any change to the
              underlying content — even a single character — produces a completely different hash.
              a successfully anchored proof therefore demonstrates that the exact, unmodified content
              corresponding to that hash existed no later than the timestamp recorded on the public
              blockchain, without this site or any third party being able to backdate it.
            </p>

            <h2>what this is — and is not</h2>
            <p>
              this mechanism is <strong>evidence of the time of existence</strong> of a specific piece of
              content. it is independent, verifiable third-party corroboration that can support an
              existing copyright claim in the event of a dispute over who published something first.
            </p>
            <p>
              it is <strong>not</strong> a copyright registration, a substitute for registering a work with
              a national copyright office, a guarantee of legal outcome, or legal advice. verification
              status shown on this site (submitted / pending / unreachable) reflects the current state
              of the public calendar servers, which are outside this site's control; a "pending" or
              temporarily unreachable status does not mean the underlying copyright is any less valid —
              it only means blockchain confirmation has not yet completed or could not be reached at
              that moment.
            </p>

            <h2>reuse and infringement</h2>
            <p>
              unless explicitly stated otherwise on an individual post, content published on this site
              may not be reproduced, redistributed, or used to train models without permission from the
              author. if you believe content on this site infringes your rights, or if you would like to
              request permission to reuse something, contact us using the details below.
            </p>

            <h2>contact</h2>
            <p>
              for copyright, licensing, or takedown requests, e-mail{" "}
              <a href="mailto:xaelserpent@gmail.com">xaelserpent@gmail.com</a>. see also our{" "}
              <Link to="/privacy">privacy policy</Link>.
            </p>

            <hr />
            <p style={{ fontSize: "0.85em", opacity: 0.75 }}>
              <Link to="/">← back to home</Link>
            </p>
          </article>
        </div>
      </main>
      <Footer show />
    </div>
  );
}
